// extracted by mini-css-extract-plugin
export default {"root":"q2YopD7SrADAHKK_LU8V"};